import React from "react";
import "./ContactUs.scss";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { END_POINTS } from "constants/APIConstant";
import GoogleMap from "component/googleMap";
import { FormattedMessage, useIntl } from "react-intl";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import OfficesList from "./components/offices-list";
// import { Exception } from "sass";
import { REGIONAL_OFFICE } from "constants/ElementsConstant";
import LabelLang, {
  LabelLangJSON,
  LabelLangString,
} from "component/LabelLang/label-lang";
import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import Mailto from "component/shared/mailto";
// import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

function ContactUs() {
  const intl = useIntl();
  const dir = useSelector(({ theme }) => theme.direction);
  const currentLocale = useSelector(({ theme }) => theme.locale);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/contact", title: "Contactus Page" });
  }, []);


  const [selectOpen, setSelectOpen] = React.useState(false);
  const selectRef = React.useRef(null);
  const defaultState = {
    governorateId: null,
    isMainLocation: false,
  };
  const [filters, setFilters] = React.useState(defaultState);
  const branchesDetailsFetching = useSWR({
    url: `${END_POINTS.REGIONAL_OFFICE_SEARCH}`,
    params: filters,
  });

  const mainBranchDetailsFetching = useSWR({
    url: `${END_POINTS.REGIONAL_OFFICE_MAIN_BRANCH}`,
  });
  const additionalOfficeFetching = useSWR({
    url: `${END_POINTS.ADDITIONAL_OFFICE}`,
  });
  const coutriesFetching = useSWR({
    url: `${END_POINTS.GOVERNORATES}`,
  });

  const configureLocations = ({ data, error, isLoading }) => {
    if (data === undefined || error || isLoading) {
      return [];
    }
    const formatingLocation =
      data === undefined
        ? []
        : data.data.map(({ latitude, longitude, name }) => {
            return {
              markerLocation: name,
              center: [latitude, longitude],
              geoLocation: [latitude, longitude],
            };
          });
    return formatingLocation;
  };
  const RenderOffices = () => {
    if (
      branchesDetailsFetching.error ||
      branchesDetailsFetching.isLoading ||
      !branchesDetailsFetching.data ||
      coutriesFetching.isLoading
    )
      return [];
    const branches = branchesDetailsFetching.data.data.map(
      (
        { name, mail, address, phoneNumber, regionalOfficeTranslations },
        index
      ) => {
        return (
          <div key={`coordinator-${index}`}>
            <OfficesList
              officeName={name}
              mail={mail}
              address={address}
              phoneNumber={phoneNumber}
              regionalOfficeTranslations={regionalOfficeTranslations}
            />
          </div>
        );
      }
    );
    return <div className="regional-offices">{branches}</div>;
  };
  const getCountryList = () => {
    if (!coutriesFetching.isLoading && !coutriesFetching.error) {
      return coutriesFetching.data.data.sort((a, b) => {
        if (dir === 'rtl') {
          return a.name < b.name ? -1 : 1
        }
        else {
          if (a.governorateTranslations?.length > 0 || a.governorateTranslations?.length > 0) {
            return a.governorateTranslations[0]?.name < b.governorateTranslations[0]?.name ? -1 : 1
          }
          return a.name < b.name ? -1 : 1
        }
      }).map(
        ({ name, id, governorateTranslations }, index) => {
          return (
            <option
              key={index + 1}
              value={id}
              title={LabelLangString({
                id: "name",
                currentLocale: currentLocale,
                defaultValue: name,
                translations: governorateTranslations,
              })}
            >
              <LabelLang
                id="name"
                defaultValue={name}
                translations={governorateTranslations}
              />
            </option>
          );
        }
      );
    }
    return [];
  };
  const onFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      return { ...prev, [name]: value === 0 || value === "0" ? null : value };
    });
  };
  const getAdditionalOffice = (itemKey) => {
    if (
      additionalOfficeFetching.data === undefined ||
      additionalOfficeFetching.error
    ) {
      return {
        officeName: "",
        mail: "",
        phoneNumber: "",
        elementTranslations: [],
      };
    }

    const additionalObj = additionalOfficeFetching.data.data.filter(
      ({ key }) => key === itemKey
    )[0];
    const { officeName, mail, phoneNumber } =
      JSON.parse(additionalObj.value) || "";
    const elementTranslations = additionalObj[TRANSLATION_KEYS.ELEMENTS];
    return { officeName, mail, phoneNumber, elementTranslations };
  };
  return (
    <ContentLoading
      isLoading={
        mainBranchDetailsFetching.isLoading ||
        additionalOfficeFetching.isLoading
      }
      className="contact-us"
      onClick={(e) => setSelectOpen(false)}
    >
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "contact-us" }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "contact-need" })}
      />
      <div className="container">
        <div className="row pt-3">
          <div className="col-12 col-lg-12">
            <div className="contact">
              <h3>
                <FormattedMessage id="head-quarter" />
              </h3>
            </div>
          </div>
          <div className="col-12 col-lg-7">
            <div className="row">
              <div className="col-12 col-lg-5">
                <div className="item-cont">
                  <img
                    loading="lazy"
                    src={process.env.PUBLIC_URL + "/image/cont1.svg"}
                    alt="item-img"
                  />
                  <span>
                    {mainBranchDetailsFetching.data &&
                    mainBranchDetailsFetching?.data?.data[0]?.address ? (
                      // <LabelLang
                      //   id="address"
                      //   defaultValue={
                      //     mainBranchDetailsFetching.data.data[0].address
                      //   }
                      //   translations={
                      //     mainBranchDetailsFetching.data.data[0][
                      //       TRANSLATION_KEYS.REGIONAL_OFFICE
                      //     ]
                      //   }
                      // />
                      LabelLangString({
                        id: "address",
                        currentLocale: currentLocale,
                        defaultValue:
                          mainBranchDetailsFetching.data.data[0].address,
                        translations:
                          mainBranchDetailsFetching.data.data[0][
                            TRANSLATION_KEYS.REGIONAL_OFFICE
                          ],
                      })
                    ) : (
                      <FormattedMessage id="data-not-found" />
                    )}
                  </span>
                </div>
              </div>
              <div className="col-12 col-lg-7">
                <div className="item-cont">
                  <img
                    loading="lazy"
                    src={process.env.PUBLIC_URL + "/image/cont2.svg"}
                    alt="item-img"
                  />
                  <span
                    dir="ltr"
                    className={dir === "rtl" ? "text-end" : "text-start"}
                  >
                    {mainBranchDetailsFetching.data &&
                    mainBranchDetailsFetching?.data?.data[0]?.phoneNumber ? (
                      mainBranchDetailsFetching.data.data[0].phoneNumber
                    ) : (
                      <FormattedMessage id="data-not-found" />
                    )}
                  </span>
                </div>
                <div className="item-cont">
                  <img
                    loading="lazy"
                    src={process.env.PUBLIC_URL + "/image/cont3.svg"}
                    alt="item-img"
                  />

                  {mainBranchDetailsFetching.data &&
                  mainBranchDetailsFetching?.data?.data[0]?.mail ? (
                    <Mailto email={mainBranchDetailsFetching.data.data[0].mail}>
                      {mainBranchDetailsFetching.data.data[0].mail}
                    </Mailto>
                  ) : (
                    <span>
                      <FormattedMessage id="data-not-found" />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12"></div>
          <div className="col-12 col-lg-6">
            <div className="map-c mb-5">
              <GoogleMap
                zoom={15}
                isGovernateSelected={true}
                defaultCenterPoint={[27.442248, 29.770797]}
                geoLocationData={configureLocations(mainBranchDetailsFetching)}
              />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="cont-info">
              <div className="cont-info-item">
                <h5>
                  <FormattedMessage id="to-request-data-or-copy-papers-from-prints-or-register-in-website" />
                </h5>
                <span>
                  {
                    <LabelLangJSON
                      id="officeName"
                      defaultValue={
                        getAdditionalOffice(
                          REGIONAL_OFFICE.INFORMATION_BANK.key
                        ).officeName
                      }
                      translations={
                        getAdditionalOffice(
                          REGIONAL_OFFICE.INFORMATION_BANK.key
                        ).elementTranslations
                      }
                    />
                  }
                </span>
                <h6
                  dir="rtl"
                  className={dir === "rtl" ? "text-end" : "text-start"}
                >
                  {
                    getAdditionalOffice(REGIONAL_OFFICE.INFORMATION_BANK.key)
                      .phoneNumber
                  }
                </h6>
                <Mailto
                  email={
                    getAdditionalOffice(REGIONAL_OFFICE.INFORMATION_BANK.key)
                      .mail
                  }
                >
                  <h6>
                    {
                      getAdditionalOffice(REGIONAL_OFFICE.INFORMATION_BANK.key)
                        .mail
                    }
                  </h6>
                </Mailto>
              </div>
              <div className="cont-info-item">
                <h5>
                  <FormattedMessage id="for-media-communication" />
                </h5>
                <span>
                  {
                    <LabelLangJSON
                      id="officeName"
                      defaultValue={
                        getAdditionalOffice(REGIONAL_OFFICE.PUBLIC_RELATION.key)
                          .officeName
                      }
                      translations={
                        getAdditionalOffice(REGIONAL_OFFICE.PUBLIC_RELATION.key)
                          .elementTranslations
                      }
                    />
                  }
                </span>

                <h6
                  dir="rtl"
                  className={dir === "rtl" ? "text-end" : "text-start"}
                >
                  {
                    getAdditionalOffice(REGIONAL_OFFICE.PUBLIC_RELATION.key)
                      .phoneNumber
                  }
                </h6>
                <Mailto
                  email={
                    getAdditionalOffice(REGIONAL_OFFICE.PUBLIC_RELATION.key)
                      .mail
                  }
                >
                  <h6>
                    {
                      getAdditionalOffice(REGIONAL_OFFICE.PUBLIC_RELATION.key)
                        .mail
                    }
                  </h6>
                </Mailto>
              </div>
              <div className="cont-info-item">
                <h5>
                  <FormattedMessage id="for-training-capacity-building-services" />
                </h5>
                <span>
                  {
                    <LabelLangJSON
                      id="officeName"
                      defaultValue={
                        getAdditionalOffice(
                          REGIONAL_OFFICE.NATIONAL_CENTER_STATISTICAL_TRAINING
                            .key
                        ).officeName
                      }
                      translations={
                        getAdditionalOffice(
                          REGIONAL_OFFICE.NATIONAL_CENTER_STATISTICAL_TRAINING
                            .key
                        ).elementTranslations
                      }
                    />
                  }
                </span>
                <h6
                  dir="rtl"
                  className={dir === "rtl" ? "text-end" : "text-start"}
                >
                  {
                    getAdditionalOffice(
                      REGIONAL_OFFICE.NATIONAL_CENTER_STATISTICAL_TRAINING.key
                    ).phoneNumber
                  }
                </h6>
                <Mailto
                  email={
                    getAdditionalOffice(
                      REGIONAL_OFFICE.NATIONAL_CENTER_STATISTICAL_TRAINING.key
                    ).mail
                  }
                >
                  <h6>
                    {
                      getAdditionalOffice(
                        REGIONAL_OFFICE.NATIONAL_CENTER_STATISTICAL_TRAINING.key
                      ).mail
                    }
                  </h6>
                </Mailto>
              </div>
              <div className="cont-info-item">
                <span>
                  {
                    <LabelLangJSON
                      id="officeName"
                      defaultValue={
                        getAdditionalOffice(
                          REGIONAL_OFFICE.HUMAN_RESOURCES_DEVELOPMENT_CENTER.key
                        ).officeName
                      }
                      translations={
                        getAdditionalOffice(
                          REGIONAL_OFFICE.HUMAN_RESOURCES_DEVELOPMENT_CENTER.key
                        ).elementTranslations
                      }
                    />
                  }
                </span>
                <h6
                  dir="rtl"
                  className={dir === "rtl" ? "text-end" : "text-start"}
                >
                  {
                    getAdditionalOffice(
                      REGIONAL_OFFICE.HUMAN_RESOURCES_DEVELOPMENT_CENTER.key
                    ).phoneNumber
                  }
                </h6>
                <Mailto
                  email={
                    getAdditionalOffice(
                      REGIONAL_OFFICE.HUMAN_RESOURCES_DEVELOPMENT_CENTER.key
                    ).mail
                  }
                >
                  <h6>
                    {
                      getAdditionalOffice(
                        REGIONAL_OFFICE.HUMAN_RESOURCES_DEVELOPMENT_CENTER.key
                      ).mail
                    }
                  </h6>
                </Mailto>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-foot">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="contact-foot-info">
                <h5>
                  <FormattedMessage id="regional-offices-accross-republican" />
                </h5>
              </div>
            </div>
            <div className="col-12 col-lg-6"></div>
            <div className="col-12 col-lg-6">
              <div className="contact-foot-info">
                <div className="item-form">
                  <label>
                    <FormattedMessage id="country-or-district" />:
                    &nbsp;&nbsp;&nbsp;
                  </label>
                  <div className="dropdown">
                    <select
                      ref={selectRef}
                      onClick={(e) => {}}
                      name="governorateId"
                      value={filters.governorateId ?? 0}
                      onChange={onFilterChange}
                    >
                      <option value={0}>
                        <FormattedMessage id="choose-location" />{" "}
                      </option>
                      {getCountryList()}
                    </select>
                    <div className="dropdown-icon" />
                  </div>
                </div>
              </div>
              <RenderOffices />
            </div>
            <div className="col-12 col-lg-6">
              <div className="map-c mb-5">
                <GoogleMap
                  defaultCenterPoint={[27.442248, 29.770797]}
                  isGovernateSelected={filters.governorateId !== null}
                  zoom={filters.governorateId === null ? 6 : 15}
                  geoLocationData={configureLocations(branchesDetailsFetching)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default ContactUs;
